import * as React from "react";
const SvgConfetti = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ...props
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_4418_9855)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.5 14C6.05228 14 6.5 13.5523 6.5 13C6.5 12.4477 6.05228 12 5.5 12C4.94771 12 4.5 12.4477 4.5 13C4.5 13.5523 4.94771 14 5.5 14Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.5 10C2.05228 10 2.5 9.55228 2.5 9C2.5 8.44771 2.05228 8 1.5 8C0.947715 8 0.5 8.44771 0.5 9C0.5 9.55228 0.947715 10 1.5 10Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.5 6C6.05228 6 6.5 5.55228 6.5 5C6.5 4.44771 6.05228 4 5.5 4C4.94771 4 4.5 4.44771 4.5 5C4.5 5.55228 4.94771 6 5.5 6Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.5 2C2.05228 2 2.5 1.55228 2.5 1C2.5 0.447715 2.05228 0 1.5 0C0.947715 0 0.5 0.447715 0.5 1C0.5 1.55228 0.947715 2 1.5 2Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M23.5 14C24.0523 14 24.5 13.5523 24.5 13C24.5 12.4477 24.0523 12 23.5 12C22.9477 12 22.5 12.4477 22.5 13C22.5 13.5523 22.9477 14 23.5 14Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.5 10C20.0523 10 20.5 9.55228 20.5 9C20.5 8.44771 20.0523 8 19.5 8C18.9477 8 18.5 8.44771 18.5 9C18.5 9.55228 18.9477 10 19.5 10Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M23.5 6C24.0523 6 24.5 5.55228 24.5 5C24.5 4.44771 24.0523 4 23.5 4C22.9477 4 22.5 4.44771 22.5 5C22.5 5.55228 22.9477 6 23.5 6Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.5 2C20.0523 2 20.5 1.55228 20.5 1C20.5 0.447715 20.0523 0 19.5 0C18.9477 0 18.5 0.447715 18.5 1C18.5 1.55228 18.9477 2 19.5 2Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.5 24C15.0523 24 15.5 23.5523 15.5 23C15.5 22.4477 15.0523 22 14.5 22C13.9477 22 13.5 22.4477 13.5 23C13.5 23.5523 13.9477 24 14.5 24Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 20C11.0523 20 11.5 19.5523 11.5 19C11.5 18.4477 11.0523 18 10.5 18C9.94771 18 9.5 18.4477 9.5 19C9.5 19.5523 9.94771 20 10.5 20Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.5 16C15.0523 16 15.5 15.5523 15.5 15C15.5 14.4477 15.0523 14 14.5 14C13.9477 14 13.5 14.4477 13.5 15C13.5 15.5523 13.9477 16 14.5 16Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 12C11.0523 12 11.5 11.5523 11.5 11C11.5 10.4477 11.0523 10 10.5 10C9.94771 10 9.5 10.4477 9.5 11C9.5 11.5523 9.94771 12 10.5 12Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.5 3C14.9696 3 14.4608 2.78929 14.0858 2.41421C13.7107 2.03914 13.5 1.53043 13.5 1C13.5 0.734784 13.3946 0.48043 13.2071 0.292893C13.0196 0.105357 12.7652 0 12.5 0C12.2348 0 11.9804 0.105357 11.7929 0.292893C11.6054 0.48043 11.5 0.734784 11.5 1C11.5 1.53043 11.2893 2.03914 10.9142 2.41421C10.5391 2.78929 10.0304 3 9.5 3C9.23478 3 8.98043 3.10536 8.79289 3.29289C8.60536 3.48043 8.5 3.73478 8.5 4C8.5 4.26522 8.60536 4.51957 8.79289 4.70711C8.98043 4.89464 9.23478 5 9.5 5C10.0304 5 10.5391 5.21071 10.9142 5.58579C11.2893 5.96086 11.5 6.46957 11.5 7C11.5 7.26522 11.6054 7.51957 11.7929 7.70711C11.9804 7.89464 12.2348 8 12.5 8C12.7652 8 13.0196 7.89464 13.2071 7.70711C13.3946 7.51957 13.5 7.26522 13.5 7C13.5 6.46957 13.7107 5.96086 14.0858 5.58579C14.4608 5.21071 14.9696 5 15.5 5C15.7652 5 16.0196 4.89464 16.2071 4.70711C16.3946 4.51957 16.5 4.26522 16.5 4C16.5 3.73478 16.3946 3.48043 16.2071 3.29289C16.0196 3.10536 15.7652 3 15.5 3Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.5 19C6.96957 19 6.46086 18.7893 6.08579 18.4142C5.71071 18.0391 5.5 17.5304 5.5 17C5.5 16.7348 5.39464 16.4804 5.20711 16.2929C5.01957 16.1054 4.76522 16 4.5 16C4.23478 16 3.98043 16.1054 3.79289 16.2929C3.60536 16.4804 3.5 16.7348 3.5 17C3.5 17.5304 3.28929 18.0391 2.91421 18.4142C2.53914 18.7893 2.03043 19 1.5 19C1.23478 19 0.98043 19.1054 0.792893 19.2929C0.605357 19.4804 0.5 19.7348 0.5 20C0.5 20.2652 0.605357 20.5196 0.792893 20.7071C0.98043 20.8946 1.23478 21 1.5 21C2.03043 21 2.53914 21.2107 2.91421 21.5858C3.28929 21.9608 3.5 22.4696 3.5 23C3.5 23.2652 3.60536 23.5196 3.79289 23.7071C3.98043 23.8946 4.23478 24 4.5 24C4.76522 24 5.01957 23.8946 5.20711 23.7071C5.39464 23.5196 5.5 23.2652 5.5 23C5.5 22.4696 5.71071 21.9608 6.08579 21.5858C6.46086 21.2107 6.96957 21 7.5 21C7.76522 21 8.01957 20.8946 8.20711 20.7071C8.39464 20.5196 8.5 20.2652 8.5 20C8.5 19.7348 8.39464 19.4804 8.20711 19.2929C8.01957 19.1054 7.76522 19 7.5 19Z",
      fill: "#1B1C1D"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M23.5 19C22.9696 19 22.4608 18.7893 22.0858 18.4142C21.7107 18.0391 21.5 17.5304 21.5 17C21.5 16.7348 21.3946 16.4804 21.2071 16.2929C21.0196 16.1054 20.7652 16 20.5 16C20.2348 16 19.9804 16.1054 19.7929 16.2929C19.6054 16.4804 19.5 16.7348 19.5 17C19.5 17.5304 19.2893 18.0391 18.9142 18.4142C18.5391 18.7893 18.0304 19 17.5 19C17.2348 19 16.9804 19.1054 16.7929 19.2929C16.6054 19.4804 16.5 19.7348 16.5 20C16.5 20.2652 16.6054 20.5196 16.7929 20.7071C16.9804 20.8946 17.2348 21 17.5 21C18.0304 21 18.5391 21.2107 18.9142 21.5858C19.2893 21.9608 19.5 22.4696 19.5 23C19.5 23.2652 19.6054 23.5196 19.7929 23.7071C19.9804 23.8946 20.2348 24 20.5 24C20.7652 24 21.0196 23.8946 21.2071 23.7071C21.3946 23.5196 21.5 23.2652 21.5 23C21.5 22.4696 21.7107 21.9608 22.0858 21.5858C22.4608 21.2107 22.9696 21 23.5 21C23.7652 21 24.0196 20.8946 24.2071 20.7071C24.3946 20.5196 24.5 20.2652 24.5 20C24.5 19.7348 24.3946 19.4804 24.2071 19.2929C24.0196 19.1054 23.7652 19 23.5 19Z",
      fill: "#1B1C1D"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_4418_9855" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white", transform: "translate(0.5)" })))
);
export default SvgConfetti;
